// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1ugod","paramInput":"JobSimulator_paramInput__2VzOe","input":"JobSimulator_input__1JzBA"};